import { useState } from 'react';

const WA_LINK = "https://wa.me/243808631779?text=Bonjour%20je%20souhaite%20m'inscrire%20à%20une%20formation";

const programs = [
  {
    id: 1,
    title: 'Électricité',
    icon: 'ri-flashlight-line',
    description: 'Installation, câblage et maintenance des systèmes électriques résidentiels et industriels.',
    duration: '3 mois',
    level: 'Débutant à Avancé',
    image: 'https://public.readdy.ai/ai/img_res/7f43c59ef41ed6f52f742eb8992cb671.jpg',
  },
  {
    id: 2,
    title: 'Énergie Solaire',
    icon: 'ri-sun-line',
    description: 'Installation et maintenance de panneaux solaires, onduleurs et systèmes photovoltaïques.',
    duration: '2 mois',
    level: 'Tous niveaux',
    image: 'https://static.readdy.ai/image/78c9a73689059983cd7950cce3ca9afd/820f5e660cc809fb5db29a843655b1e9.png',
  },
  {
    id: 3,
    title: 'Fibre Optique',
    icon: 'ri-router-line',
    description: 'Soudure, installation et test de réseaux fibre optique pour télécommunications.',
    duration: '2 mois',
    level: 'Intermédiaire',
    image: 'https://static.readdy.ai/image/78c9a73689059983cd7950cce3ca9afd/a34edb38eaccbc7cfa67af3bc0fd8813.png',
  },
  {
    id: 4,
    title: 'Téléphonie GSM',
    icon: 'ri-smartphone-line',
    description: 'Réparation, déblocage et maintenance des téléphones mobiles et smartphones.',
    duration: '1.5 mois',
    level: 'Débutant',
    image: 'https://static.readdy.ai/image/78c9a73689059983cd7950cce3ca9afd/c000c222064b471f5390521a1ad0e5e6.png',
  },
  {
    id: 5,
    title: 'Sécurité & CCTV',
    icon: 'ri-shield-check-line',
    description: 'Installation de caméras de surveillance, alarmes et systèmes de contrôle d\'accès.',
    duration: '2 mois',
    level: 'Tous niveaux',
    image: 'https://static.readdy.ai/image/78c9a73689059983cd7950cce3ca9afd/e221ac0441815927d19ebfc425807654.png',
  },
  {
    id: 6,
    title: 'Développement Web',
    icon: 'ri-code-s-slash-line',
    description: 'HTML, CSS, JavaScript, React et création de sites web professionnels.',
    duration: '4 mois',
    level: 'Débutant à Pro',
    image: 'https://readdy.ai/api/search-image?query=web%20development%20coding%20programming%20laptop%20students%20training%20center%20Africa%20technology%20modern%20classroom&width=400&height=540&seq=prog006&orientation=portrait',
  },
  {
    id: 7,
    title: 'Intelligence Artificielle',
    icon: 'ri-robot-line',
    description: 'Initiation à l\'IA, machine learning, ChatGPT et outils d\'automatisation.',
    duration: '3 mois',
    level: 'Intermédiaire',
    image: 'https://readdy.ai/api/search-image?query=artificial%20intelligence%20machine%20learning%20technology%20training%20students%20Africa%20modern%20digital%20education%20professional&width=400&height=540&seq=prog007&orientation=portrait',
  },
  {
    id: 8,
    title: 'Business & Entrepreneuriat',
    icon: 'ri-briefcase-line',
    description: 'Gestion d\'entreprise, marketing digital, comptabilité et création de startup.',
    duration: '2 mois',
    level: 'Tous niveaux',
    image: 'https://readdy.ai/api/search-image?query=business%20entrepreneurship%20training%20workshop%20Africa%20young%20professionals%20marketing%20management%20startup%20education&width=400&height=540&seq=prog008&orientation=portrait',
  },
];

export default function TrainingSection() {
  const [hovered, setHovered] = useState<number | null>(null);

  return (
    <section id="formations" className="py-24 bg-[#0a1628]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-[#f5c518]/20 text-[#f5c518] text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
            Nos Programmes
          </span>
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
            Formations Professionnelles
          </h2>
          <p className="text-white/60 text-lg max-w-2xl mx-auto">
            8 filières techniques et digitales pour booster votre carrière à Kinshasa et au-delà.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {programs.map((prog) => (
            <div
              key={prog.id}
              className="relative rounded-2xl overflow-hidden cursor-pointer group transition-transform duration-300 hover:-translate-y-2"
              style={{ height: '420px' }}
              onMouseEnter={() => setHovered(prog.id)}
              onMouseLeave={() => setHovered(null)}
            >
              {/* Background Image */}
              <img
                src={prog.image}
                alt={prog.title}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a1628] via-[#0a1628]/60 to-transparent"></div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-6">
                {/* Icon */}
                <div className="w-10 h-10 flex items-center justify-center bg-[#f5c518] rounded-full mb-3">
                  <i className={`${prog.icon} text-[#0a1628] text-lg`}></i>
                </div>

                {/* Title */}
                <h3 className="text-white font-bold text-xl mb-2">{prog.title}</h3>

                {/* Description */}
                <p className="text-white/80 text-sm leading-relaxed mb-3 line-clamp-2 group-hover:line-clamp-none transition-all duration-300">
                  {prog.description}
                </p>

                {/* Meta */}
                <div className="flex items-center gap-3 mb-4">
                  <span className="bg-[#f5c518]/20 text-[#f5c518] text-xs font-semibold px-3 py-1 rounded-full">
                    {prog.duration}
                  </span>
                  <span className="text-white/50 text-xs">{prog.level}</span>
                </div>

                {/* WhatsApp Button - appears on hover */}
                <a
                  href={WA_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 bg-white text-[#0a1628] font-bold text-sm px-4 py-2.5 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-300 translate-y-2 group-hover:translate-y-0 whitespace-nowrap cursor-pointer"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-whatsapp-line text-green-500 text-base"></i>
                  </div>
                  S'inscrire maintenant
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-14">
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#f5c518] text-[#0a1628] font-bold text-base px-10 py-4 rounded-full hover:bg-yellow-400 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-whatsapp-line text-lg"></i>
            </div>
            Demander plus d'informations
          </a>
        </div>
      </div>
    </section>
  );
}
